const validateFloat = value => {
  if (value == null || typeof value === 'undefined') return 'Required';
  if (value.toString().trim().length < 1) return 'Required';
  if (isNaN(value)) return 'Invalid valid. Should be a number.';
  if (parseFloat(value) < 0) return "Value can't be less than 0";
  return false;
};
export default validateFloat;
